module.exports = __webpack_public_path__ + "img/4.866ccdca.jpg";